var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCountBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 190,
    height: 71,
    viewBox: "0 0 190 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.270508 23.3539C0.270508 10.7336 10.5012 0.50293 23.1214 0.50293H166.575C179.195 0.50293 189.425 10.7336 189.425 23.3539V47.4743C189.425 60.0945 179.195 70.3252 166.575 70.3252H23.1214C10.5012 70.3252 0.270508 60.0945 0.270508 47.4743V23.3539Z",
    fill: "#0A21A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.696 24.6234C11.696 14.1065 20.2216 5.58092 30.7384 5.58092H158.958C169.474 5.58092 178 14.1065 178 24.6234V44.9353C178 55.4522 169.474 63.9778 158.958 63.9778H30.7384C20.2216 63.9778 11.696 55.4522 11.696 44.9353V24.6234Z",
    fill: "url(#paint0_linear_319_29994)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M178.084 47.6327V22.7188C178.084 22.7188 177.039 16.6655 174.911 13.515C172.721 10.2732 167.294 7.00879 167.294 7.00879V45.2524C166.659 48.6641 164.032 51.7427 159.196 55.7257C153.987 60.0154 98.3171 61.8425 74.4617 64.1361H79.376C103.126 64.0832 152.34 64.0092 159.196 64.1361C166.051 64.2631 177.132 58.2647 178.084 47.6327Z",
    fill: "#EBE0E0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_319_29994",
    x1: 25.8083,
    y1: 6.08118,
    x2: 51.9749,
    y2: 104.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountBox);
export default __webpack_public_path__ + "static/media/CountBox.90b9e7641e813a15897e.svg";
export { ForwardRef as ReactComponent };